import type { GenericEventName, GenericEventParams, GenericEventTag } from "../types/logging";

import { NativeModules } from "react-native";

export type InterviewPrepNativeModule = Partial<{
  logInterviewPrepEvent(
    commonEventName: string,
    eventType: string,
    eventName: GenericEventName,
    eventVersion: number,
    tags?: GenericEventTag[],
    params?: GenericEventParams,
  ): Promise<void>;

  checkMicrophonePermission(): Promise<"granted" | "needed" | "blocked">;
  requestMicrophonePermission(): Promise<"granted" | "denied">;
  closeReactFragment(): Promise<void>;
}>;

const MODULE_NAME = "InterviewPrepModule";

/**
 * Entry point for accessing the Interview Prep native module.
 *
 * Do not access the react-native NativeModules object directly outside of this method.
 *
 * CAUTION: This is fake type-safety. It assumes the native modules are defined correctly.
 */
export function interviewPrepNativeModule(): InterviewPrepNativeModule | null | undefined {
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- RN-5783 baseline: pre-existing cast; migrate to zod/proper types (see docs/type-assertions.md)
  return NativeModules[MODULE_NAME] as InterviewPrepNativeModule | null | undefined;
}
